import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import arePropsEqual from 'react-fast-compare';
import { Icon } from '@modulor/react';
import { useGameAdditionalInfo } from '../hooks';

const GameCardSeats = ({ className, gameId, iconClassName }) => {
  const { seatsTaken } = useGameAdditionalInfo(gameId);

  const seats = Number.isInteger(seatsTaken) ? seatsTaken : null;

  return useMemo(
    () =>
      seats ? (
        <div className={className}>
          <Icon name="group" size={14} className={iconClassName} />
          {seats}
        </div>
      ) : null,
    [seats, iconClassName, className]
  );
};

GameCardSeats.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
};

export default React.memo(GameCardSeats, arePropsEqual);
